import * as React from 'react'

const styles = {
  width: 24,
  height: 24
}

export default () => (
  <svg
    style={styles}
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <linearGradient id="a">
      <stop offset="0" stopColor="#ffc107" />
      <stop offset=".507" stopColor="#f44336" />
      <stop offset=".99" stopColor="#9c27b0" />
    </linearGradient>
    <linearGradient
      id="b"
      gradientTransform="matrix(32 0 0 -32 1519 20757)"
      gradientUnits="userSpaceOnUse"
      x1="-46.0041"
      x2="-32.9334"
      xlinkHref="#a"
      y1="634.1208"
      y2="647.1917"
    />
    <linearGradient
      id="c"
      gradientTransform="matrix(32 0 0 -32 1519 20757)"
      gradientUnits="userSpaceOnUse"
      x1="-42.2971"
      x2="-36.6404"
      xlinkHref="#a"
      y1="637.8279"
      y2="643.4846"
    />
    <linearGradient
      id="d"
      gradientTransform="matrix(32 0 0 -32 1519 20757)"
      gradientUnits="userSpaceOnUse"
      x1="-35.5456"
      x2="-34.7919"
      xlinkHref="#a"
      y1="644.5793"
      y2="645.3331"
    />
    <path
      d="m352 0h-192c-88.352 0-160 71.648-160 160v192c0 88.352 71.648 160 160 160h192c88.352 0 160-71.648 160-160v-192c0-88.352-71.648-160-160-160zm112 352c0 61.76-50.24 112-112 112h-192c-61.76 0-112-50.24-112-112v-192c0-61.76 50.24-112 112-112h192c61.76 0 112 50.24 112 112z"
      fill="url(#b)"
    />
    <path
      d="m256 128c-70.688 0-128 57.312-128 128s57.312 128 128 128 128-57.312 128-128-57.312-128-128-128zm0 208c-44.096 0-80-35.904-80-80 0-44.128 35.904-80 80-80s80 35.872 80 80c0 44.096-35.904 80-80 80z"
      fill="url(#c)"
    />
    <circle cx="393.6" cy="118.4" fill="url(#d)" r="17.056" />
  </svg>
)
